import { render, staticRenderFns } from "./routing-add-or-update.vue?vue&type=template&id=62d95b43&scoped=true"
import script from "./routing-add-or-update.vue?vue&type=script&lang=js"
export * from "./routing-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./routing-add-or-update.vue?vue&type=style&index=0&id=62d95b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d95b43",
  null
  
)

export default component.exports